import { storiesData } from '../data/storiesData';
import { questionsData } from '../data/questionsData';

// Function to merge backend stories with frontend questions
export const mergeStoriesWithQuestions = () => {
  return storiesData.map((story) => {
    const storyQuestions = questionsData.find((q) => q.storyId === story.id);
    return {
      ...story,
      questions: storyQuestions ? storyQuestions.questions : [],
    };
  });
};

// Get the merged stories data
export const stories = mergeStoriesWithQuestions();